<script lang="ts">
  import type { CustomBlockComponentProps } from '@portabletext/svelte';

  export let portableText: CustomBlockComponentProps<{
    listItem: 'number' | 'bullet';
  }>;
</script>

<svelte:element this={portableText.value.listItem === 'number' ? 'ol' : 'ul'}>
  <slot />
</svelte:element>

<style>
  ul,
  ol {
    margin: 0;
    padding: 0;
    margin-left: 20px;
    list-style-position: outside;
  }
</style>
